import React from "react";
import pageNotFound from "../../assets/page-not-found.jpg";
import "./style.css";

const PageNotFound = () => {
  return (
    <div className="page-not-found-wrapper">
      <div className="page-not-found-container">
        <img src={pageNotFound} alt="page-not-found" />
      </div>
    </div>
  );
};

export default PageNotFound;
